/* Home.js*/
import { useEffect, useState, useRef } from "react";
import api from "../api/axios";
import "../styles/Home.css";
import fondo from "../components/fondo.jpg";
import logo from "../components/logo.png";
import imagen1 from "../components/imagen1.png";
import imagen2 from "../components/imagen2.png";




function Home() {
  const [mensaje, setMensaje] = useState("");
/*Todo esto puesto para que aparezca contenido al hacer scroll */
  const section2Ref = useRef(null);

useEffect(() => {
  const onScroll = () => {
    if (!section2Ref.current) return;
    const top = section2Ref.current.getBoundingClientRect().top;
    const screenHeight = window.innerHeight;

    if (top < screenHeight - 100) {
      section2Ref.current.classList.add("active");
    }
  };

  window.addEventListener("scroll", onScroll);
  return () => window.removeEventListener("scroll", onScroll);
}, []);


/*Ahora esto es para obtener un mensaje del backend */
  useEffect(() => {
    api.get("/")
      .then(res => setMensaje(res.data.mensaje))
      .catch(err => console.error(err));
  }, []);

      return (
        /*aqui empieza la pagina*/

<div className="page">

     <section
      className="home-container"
      style={{ backgroundImage: `url(${imagen1})` }}
    >
      <div className="overlay">
        <img src={logo} alt="Logo M3" className="logo" />
        <h1 className="title">Bienvenido a M3 Campus</h1>
        <p className="subtitle">
          Un espacio para aprender, crecer y descubrir nuevos conocimientos
          desde cualquier lugar, para todas las edades.
        </p>
        {/* Mensaje que llega desde Django */}
        {mensaje && <p className="backend-message">{mensaje}</p>}
      </div>
 
       
      
    </section>

{/**Empiezo la seccion 2 */}
    <section
  ref={section2Ref}
  className="home-container2 reveal"
  style={{ backgroundImage: `url(${fondo})` }}
>
  <div className="section2-left">
     <div className="overlay2">
    <p className="subtitle2">
      Campus de tecnologías emergentes adaptados a todas las edades, si quiere asegurar el futuro de sus hijos o si siente que los modelos educativos no están adaptados a la realidad, este es el lugar correcto.
      En m3campus, nos preocupamos por educar de una manera divertida y comprensiva para la edad que requiera. Personal cualificado y con experiencia se asegurará que los jóvenes interiorizan los conocimientos aprendidos, familiarizándolos
      de cara a un futuro próximo y despertando en ellos, curiosidad y capacidad para realizar proyectos incluso a edades tempranas. 
   
    </p>
      </div>
  </div>

  <div className="section2-right">
    <img src={imagen2} alt="imagen2" className="right-image" />
  </div>
</section>

</div>

  );
}

export default Home;
